/* eslint-disable no-console */
import React, { useEffect, useState } from 'react'
import { loaderService } from 'src/services/loaderService'
import bussinesUnits from '../../services/bussinesUnits'
import BussinessUnitList from '../../components/homeDashboard/BusinessUnitList'

const BussninesUnitContainer = () => {
  const [data, setData] = useState(null)

  useEffect(() => {
    loaderService.show()
    bussinesUnits
      .getUnidades()
      .then((response) => {
        setData(response.data)
        loaderService.hide()
      })
      .catch((error) => {
        console.log(error)
        loaderService.hide()
      })
  }, [])

  return <BussinessUnitList data={data} />
}

export default BussninesUnitContainer
